import { t } from '../i18n'

const SAVE_KEY = 'gpt-clicker-save'

export const SaveSystem = {
  save(data: string): void {
    try {
      localStorage.setItem(SAVE_KEY, data)
    } catch (e) {
      console.error(t('consoleFailedToSave'), e)
    }
  },

  load(): string | null {
    try {
      return localStorage.getItem(SAVE_KEY)
    } catch (e) {
      console.error(t('consoleFailedToLoad'), e)
      return null
    }
  },

  clear(): void {
    try {
      localStorage.removeItem(SAVE_KEY)
    } catch (e) {
      console.error(t('consoleFailedToClear'), e)
    }
  },

  hasSave(): boolean {
    return localStorage.getItem(SAVE_KEY) !== null
  }
}
